/* eslint-disable */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Form} from 'react-redux-form';
import {Modal} from 'react-bootstrap';
import RequiredInput from '../../common/form/elements/required-input';
import RequiredTextarea from '../../common/form/elements/required-textarea';
import ArrowButton from '../../common/button-arrow';

class MessageDialog extends Component {
  render() {
    const {onClose, onMessageSend, formValid, to} = this.props;
    
    return (
      
      <Modal
        show={true}
        container={this}
        aria-labelledby="contained-modal-title"
      >
        <Modal.Header>
          <Modal.Title><h5>Send message to: {to}</h5></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form model="deep.store_message" onSubmit={onMessageSend}>
            <RequiredInput model=".subject" placeholder="Subject" label="Subject"/>
            <RequiredTextarea model=".body" label="Message" placeholder="Type your message here..."/>
            <div className="mg-top-20" style={{height: 50}}>
              <ArrowButton
                color="grey"
                className="pull-left"
                submit={false}
                arrow={false}
                disabled={false}
                onClick={() => onClose(false)}
              >
                Cancel
              </ArrowButton>
              
              <ArrowButton
                color="red"
                className="pull-right"
                submit
                arrow={false}
                disabled={!formValid}
              >
                Send
              </ArrowButton>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

MessageDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  formValid: state.deep.forms.store_message.$form.valid,
});

export default connect(mapStateToProps)(MessageDialog);



// WEBPACK FOOTER //
// ./src/components/team/my-stores/message-dialog.jsx